module.exports = __webpack_public_path__ + "img/section1SwiperTab1.742ddc57.png";